import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppBar from "../../common/AppBar";
import { deleteTask } from "../../redux/taskSlice";
import "./Tasks.css";

const columnNames = [
  "Pin",
  "Reference*",
  "Tags",
  "Task*",
  "Status*",
  "Progress",
  "Due",
  "Created on",
  "Assigned to*",
  "Action",
];

const Tasks = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [visibleColumns, setVisibleColumns] = useState(columnNames);
  const [searchQuery, setSearchQuery] = useState("");
  const [limit, setLimit] = useState(5);
  const [offset, setOffset] = useState(0);

  const { tasks, loading, error, pagination } = useSelector(
    (state) => state.tasks
  );

  useEffect(() => {
    // dispatch(getAllTasks({ limit, offset }));
  }, [dispatch, limit, offset]);

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this task?")) {
      dispatch(deleteTask(id));
      // dispatch(getAllTasks({ limit, offset }));
    }
  };

  const handleAddRow = () => {
    navigate("/add-task");
  };

  return (
    <div>
      <AppBar title="Tasks" buttons={[]} />
      <div className="search-header">
        <input
          type="text"
          placeholder="Type to Search..."
          className="search-input"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        {searchQuery && (
          <button className="clear-button" onClick={() => setSearchQuery("")}>
            x
          </button>
        )}
      </div>
      <div className="button-container">
        <button className="appbar-button" onClick={handleAddRow}>
          + Add Task
        </button>
        <button className="appbar-button">Add via CSV</button>
        <button className="appbar-button">Update via CSV</button>
        <button className="appbar-button">Export CSV</button>
      </div>
      {loading && <p>Loading tasks...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      {!loading && !error && (
        <table className="table">
          <thead>
            <tr>
              {visibleColumns.map((col) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tasks.map((row, index) => (
              <tr key={row.id || index}>
                {visibleColumns.includes("Pin") && (
                  <td>{row.pin ? "📌" : ""}</td>
                )}
                {visibleColumns.includes("Reference*") && (
                  <td>{row.reference}</td>
                )}
                {visibleColumns.includes("Tags") && <td>{row.tags}</td>}
                {visibleColumns.includes("Task*") && <td>{row.task}</td>}
                {visibleColumns.includes("Status*") && <td>{row.status}</td>}
                {visibleColumns.includes("Progress") && (
                  <td>{row.progress}%</td>
                )}
                {visibleColumns.includes("Due") && <td>{row.due}</td>}
                {visibleColumns.includes("Created on") && (
                  <td>{row.created_on}</td>
                )}
                {visibleColumns.includes("Assigned to*") && (
                  <td>{row.assigned_to}</td>
                )}
                {visibleColumns.includes("Action") && (
                  <td className="action-buttons">
                    <button
                      className="edit-row"
                      onClick={() =>
                        navigate("/add-task", {
                          state: { editMode: true, task: row },
                        })
                      }
                    >
                      ✎
                    </button>
                    <button
                      className="delete-row"
                      onClick={() => handleDelete(row.id)}
                    >
                      🗑
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div className="pagination">
        <button
          onClick={() => setOffset((prev) => Math.max(prev - limit, 0))}
          disabled={offset === 0}
        >
          Prev
        </button>
        <span>
          Page {offset / limit + 1} of {pagination?.totalPages || 1}
        </span>
        <button
          onClick={() => setOffset((prev) => prev + limit)}
          disabled={offset / limit + 1 >= (pagination?.totalPages || 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Tasks;
